<template>
  <div class="logistics">
    <div class="logistics_nav">
      <form action="/">
        <van-search
          v-model="value"
          show-action
          placeholder="请输入物流公司名称"
          @search="onSearch"
          @cancel="onCancel"
        />
      </form>
    </div>
    <div class="box">
      <van-row class="show_logistics_row">
        <van-col
          span="24"
          class="show_logistics"
          v-for="(item, index) in list"
          :key="index"
        >
          {{ item.name }}
        </van-col>
      </van-row>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      list: [],
      value: "",
    };
  },
  mounted() {
    document.documentElement.style.setProperty(
      "font-size",
      (document.body.clientWidth / 375) * 10 + "px"
    );
  },
  created() {
    // this.list = JSON.parse(localStorage.getItem("nowList"));
    localStorage.removeItem("nowList");
  },
  methods: {
    onCancel() {
      this.$router.go(-1);
    },
    onSearch(val) {
      localStorage.setItem("searchVal", val);
      this.$router.go(-1);
    },
  },
};
</script>
<style>
html {
  font-size: calc(var(--sizeScale2) * 10px);
}
</style>
<style lang="less" scoped>
.logistics {
  height: 100%;
  box-sizing: border-box;
  background: #f5f6f7;

  .logistics_nav {
    position: fixed;
    top: 0;
    width: 100%;
    padding-top: 4.4rem;
    background-color: #ffffff;
    z-index: 3;
    box-shadow: 0 0 0.8rem 0 rgba(153, 153, 153, 0.2);

    .van-search {
      height: 4.4rem;
      line-height: 4.4rem;
      padding: 0 0.8rem 1.4rem 1.6rem;
      box-sizing: border-box;

      .van-search__content {
        padding-left: 2rem;
        line-height: 3rem;
        font-size: 1.4rem;

        .van-cell {
          height: 3rem;
          border-radius: 1.5rem;
        }
      }
    }
  }

  .box {
    padding: 8.8rem 0 0;
    box-sizing: border-box;
    height: 100%;
    background: #f5f6f7;
    overflow-y: scroll;
    -webkit-overflow-scrolling: touch;

    .show_logistics_row {
      height: 5.7rem;
      padding: 0 1.6rem;
      box-sizing: border-box;

      .show_logistics {
        color: #666;
        font-size: 1.7rem;
        height: 5.6rem;
        line-height: 5.6rem;
        padding: 0 0.5rem;
        text-align: left;
        border-bottom: solid 0.05rem #ccc;
        box-sizing: border-box;
      }
    }
  }
}
</style>